/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const TOAST_MESSAGE_TYPE = {
    FROM_TOP_LEFT: 'from-top-left',
};
